<template>
  <div>
    <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>欢迎</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    <!-- <h4>
      有问题请
      <a target="_blank" href="https://qm.qq.com/cgi-bin/qm/qr?k=8qWXYM_veH3ln6YTvb6sMYr_CVB29qSY&jump_from=webapi">加群 675107742<img border="0" src="//pub.idqqimg.com/wpa/images/group.png" alt="7C云网络验证" title="7C云网络验证"></a>交流
    </h4> -->
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
  a{
    text-decoration: none;
  }
  h4{
    margin: 20px;
  }
</style>